module.exports = __webpack_public_path__ + "img/04—01—01—Settings > Warning.54a92918.jpg";